import {
  GET_LIST_MMC_SUCCESS,
  GET_LIST_PROVINCES_SUCCESS,
  GET_LIST_MERCHANT_BY_PHONE,
  GET_LIST_SHOP_BY_MERCHANT_CODE,
  GET_LIST_MERCHANT_BY_CODE,
  UPDATE_STEP,
  UPDATE_SEARCH_CRITERIA,
  CHOOSED_MERCHANT,
  CHOOSED_SHOP,
  GET_LIST_SERVICE,
  UPDATE_SEND_DATA,
  UPDATE_SELECTED_SERVICES,
} from './action_type';
import { REDUCER_ACTION } from './type';

const initialState = {
  listMMC: null,
  listProvinces: null,
  listMerchantPhone: null,
  listMerchantCode: null,
  listShops: null,
  listServices: null,
  step: 1,
  searchCriteria: {},
  choosed_merchant: {},
  choosed_shop: {},
  create_data: {},
  services: [],
};

function createMerchantReducer(state = initialState, action: REDUCER_ACTION) {
  switch (action.type) {
    case GET_LIST_MMC_SUCCESS:
      return { ...state, listMMC: action.listMMC };
    case GET_LIST_PROVINCES_SUCCESS:
      return { ...state, listProvinces: action.listProvinces };
    case GET_LIST_MERCHANT_BY_PHONE:
      return { ...state, listMerchantPhone: action.listMerchantPhone };
    case GET_LIST_MERCHANT_BY_CODE:
      return { ...state, listMerchantCode: action.listMerchantCode };
    case GET_LIST_SHOP_BY_MERCHANT_CODE:
      return { ...state, listShops: action.listShops };
    case GET_LIST_SERVICE:
      return { ...state, listServices: action.listServices };
    case UPDATE_STEP:
      return { ...state, step: action.step };
    case UPDATE_SEARCH_CRITERIA:
      return {
        ...state,
        searchCriteria: {
          ...state.searchCriteria,
          ...action.searchCriteria,
        },
      };
    case CHOOSED_MERCHANT:
      return { ...state, choosed_merchant: action.choosed_merchant };
    case UPDATE_SEND_DATA:
      return { ...state, create_data: action.create_data };
    case UPDATE_SELECTED_SERVICES:
      return { ...state, services: action.services };
    case CHOOSED_SHOP:
      return { ...state, choosed_shop: action.choosed_shop };
    default:
      return state;
  }
}

export default createMerchantReducer;
